import { QueryBuilderAstNodeType } from '../../../../types';

type ShouldShowInvalidHintArgsType = {
  tokenCount: number;
  ast: QueryBuilderAstNodeType | null;
};

export const shouldShowInvalidHint = ({
  tokenCount,
  ast,
}: ShouldShowInvalidHintArgsType): boolean => tokenCount > 0 && ast === null;
